import male90b from './TCALCI_broad_male_90.png';
import male95b from './TCALCI_broad_male_95.png';
import male99b from './TCALCI_broad_male_99.png';
import male90s from './TCALCI_specific_male_90.png';
import male95s from './TCALCI_specific_male_95.png';
import male99s from './TCALCI_specific_male_99.png';
import female90b from './TCALCI_broad_female_90.png';
import female95b from './TCALCI_broad_female_95.png';
import female99b from './TCALCI_broad_female_99.png';
import female90s from './TCALCI_specific_female_90.png';
import female95s from './TCALCI_specific_female_95.png';
import female99s from './TCALCI_specific_female_99.png';

export default {
  male90: [male90b, male90s],
  male95: [male95b, male95s],
  male99: [male99b, male99s],
  female90: [female90b, female90s],
  female95: [female95b, female95s],
  female99: [female99b, female99s],
};
